module.exports = __webpack_public_path__ + "static/media/santhanaraj.db232d32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/santhanaraj.jpg
// module id = 230
// module chunks = 0